"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * An item view for images
 *
 * Supports plugins ("overlays") which can customize behavior and look or individual
 * items according to client needs
 */
var ImageItemView = /** @class */ (function () {
    function ImageItemView(item, overlays, container) {
        this.overlays = overlays;
        this.container = container;
        this.overlayDestructors = [];
        this.item = item;
    }
    ImageItemView.prototype.setGeometry = function (geometry) {
        this.rect = geometry;
        if (this.element) {
            Object.assign(this.element.style, {
                position: 'absolute',
                left: geometry.x + 'px',
                top: geometry.y + 'px',
                width: geometry.width + 'px',
                height: geometry.height + 'px'
            });
        }
    };
    ImageItemView.prototype.update = function (item) {
        var _this = this;
        var oldUrl = this.item.url;
        var newUrl = item.url;
        this.item = item;
        if (this.element) {
            var preload = oldUrl !== newUrl
                ? exports.T.tryPreloadImage(newUrl).catch(function (e) { return e; }).finally(function () { return _this.applyUrl(newUrl); })
                : Promise.resolve();
            this.rebuildOverlays(this.element);
            return preload;
        }
    };
    ImageItemView.prototype.getRect = function () {
        return this.rect;
    };
    ImageItemView.prototype.load = function () {
        var element = document.createElement('div');
        Object.assign(element.style, {
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
        });
        this.buildOverlays(element);
        this.container.appendChild(element);
        this.element = element;
        this.setGeometry(this.rect);
        this.applyUrl(this.item.url);
    };
    ImageItemView.prototype.unload = function () {
        if (this.element) {
            this.destroyOverlays();
            this.container.removeChild(this.element);
            this.element = null;
        }
    };
    ImageItemView.prototype.buildOverlays = function (element) {
        var _this = this;
        this.overlayDestructors = this.overlays.map(function (overlay) { return overlay(_this.item, element); });
    };
    ImageItemView.prototype.destroyOverlays = function () {
        this.overlayDestructors.reverse().forEach(function (f) { return f(); });
        this.overlayDestructors = [];
    };
    ImageItemView.prototype.rebuildOverlays = function (element) {
        this.destroyOverlays();
        this.buildOverlays(element);
    };
    ImageItemView.prototype.applyUrl = function (url) {
        if (this.element) {
            this.element.style.backgroundImage = "url(" + url + ")";
        }
    };
    return ImageItemView;
}());
exports.ImageItemView = ImageItemView;
/**
 * Request an image and wait until it is likely stored in the browser
 * cache. This is used to pre-load an image before setting it as a backround
 * to item <div> to avoid the blinking.
 */
function tryPreloadImage(url) {
    return new Promise(function (resolve, reject) {
        var img = new Image();
        img.onload = function () { return resolve(img.src); };
        img.onerror = reject;
        img.src = url;
    });
}
exports.T = { tryPreloadImage: tryPreloadImage }; // Exposed for unit tests
